import { React, useState, useContext, useRef } from "react";

import { TrashIcon } from "@heroicons/react/solid";

import { AppContext } from '../Provider/Provider';

import Dropdown from './DropdownComponent';
import Tabla from './TablaComponent';

const InputCard = ({ nombreCategoria, electrodomesticos, cantidad, usoDiario }) => {

  const [valoresConsumoState, setValoresConsumoState] = useContext(AppContext);

  const [electrodomesticoState, setElectrodomesticoState] = useState({});
  const [cantidadState, setCantidadState]   = useState({});
  const [usoDiarioState, setUsoDiarioState] = useState({});
  const [inputDataState, setInputDataState] = useState([]);

  const [electroDropdownIsEmpty, setElectroDropdownIsEmpty]     = useState(true);
  const [cantidadDropdownIsEmpty, setCantidadDropdownIsEmpty]   = useState(true);
  const [usoDiarioDropdownIsEmpty, setUsoDiarioDropdownIsEmpty] = useState(true);
  
  /** Para limpiar los dropdowns */
  const [clearElectro, setClearElectro]     = useState(false);
  const [clearCantidad, setClearCantidad]   = useState(false);
  const [clearUsoDiario, setClearUsoDiario] = useState(false);
  

  const tablaRef = useRef();
  
  /** Obtiene los datos de los dropdowns */
  function handleElectrodomestico(item) {
    var localObj = valoresConsumoState;
    // Deshabilita el uso diario para los termotanques o heladeras
    if(item.name.includes("Termotanque") || item.name.includes("Heladera"))
    {  
      localObj.disableDropdown = true;
      setUsoDiarioDropdownIsEmpty(false);
    }
    else
      localObj.disableDropdown = false;

    setValoresConsumoState(localObj);
    setElectrodomesticoState(item);
    setElectroDropdownIsEmpty(false);
    
  }

  function handleCantidad(item) {
    setCantidadState(item);
    setCantidadDropdownIsEmpty(false);
  }

  function handleUsoDiario(item) {
    setUsoDiarioState(item);
    setUsoDiarioDropdownIsEmpty(false);
  }
  /** ---------------------------------- */

  /** ------ Limpia los dropdowns ------ */
  function handleClearElectro(clearItem) {
    setClearElectro(clearItem);
  }
  function handleClearCantidad(clearItem) {
    setClearCantidad(clearItem);
  }
  function handleClearUsoDiario(clearItem) {
    setClearUsoDiario(clearItem);
  }
  /** ---------------------------------- */

  if (valoresConsumoState.clearDropdown) {
    enableClear();

    let localObj = valoresConsumoState;
    
    localObj.clearDropdown = false;
    setValoresConsumoState(localObj);
  }


  function handleInputDataOnClick() {
    if (!electroDropdownIsEmpty 
        && !cantidadDropdownIsEmpty
        && !usoDiarioDropdownIsEmpty
      ) 
    {
      var valorUsoDiario = 0;
      var nombreUsoDiario = "";
      if(electrodomesticoState.name.includes("Termotanque")){
        valorUsoDiario = 2.5;
        nombreUsoDiario = valorUsoDiario + " hs.";
      }
      else if(electrodomesticoState.name.includes("Heladera")){
        valorUsoDiario = 24;
        nombreUsoDiario = valorUsoDiario + " hs.";
      }
      else{ 
        valorUsoDiario = usoDiarioState.value;
        nombreUsoDiario = usoDiarioState.name;
      }

      let digitos = 2;
      
      var calcKWH =
      cantidadState.name *
      (electrodomesticoState.W / 1000) *
      valorUsoDiario;
      
      var calcBim = calcKWH * 60;
      
      calcKWH =
      Math.trunc(calcKWH * Math.pow(10, digitos)) / Math.pow(10, digitos);
      calcBim =
      Math.trunc(calcBim * Math.pow(10, digitos)) / Math.pow(10, digitos);
      
      let inputData = {
        electrodomestico: electrodomesticoState.name,
        cantidad: cantidadState.name,
        kWh: calcKWH,
        usoDiario: nombreUsoDiario,
        consumoBimestral: calcBim,
      };

      setInputDataState(inputData);

      handleTotalkWhCategoria();
      
      disableButton();

      enableClear();
    }
  }

  function disableButton() {
    setElectroDropdownIsEmpty(true);
    setCantidadDropdownIsEmpty(true);
    setUsoDiarioDropdownIsEmpty(true);
  }

  function enableClear() {
    var localObj = valoresConsumoState;
    localObj.disableDropdown = false;
    
    setClearElectro(true);
    setClearCantidad(true);
    setClearUsoDiario(true);
    
    setValoresConsumoState(localObj);

  }


  function handleTotalkWhCategoria(tableData) {
    
    if (typeof tableData !== "undefined" && typeof nombreCategoria !== "undefined") {
      let localObj = valoresConsumoState;
      let digitos = 2;
      localObj.ValoresCategoriaCard[nombreCategoria].kWh = tableData;
      localObj.TotalkWhBim = tableData; //poner la suma total. 
      localObj.TotalkWhBim = Math.trunc(localObj.TotalkWhBim * Math.pow(10, digitos)) / Math.pow(10, digitos);
      setValoresConsumoState(localObj);
    }
  }

  function handleDeleteTableOnClick(){
    /** Acá se llama a la función de TablaComponent */
    tablaRef.current.clearArrayOfElements();
  }

  return (
    <div className={"w-full bg-gray-100 border-solid border-2 border-green-600 | py-4 px-2 md:px-6 rounded-md | shadow-md center"}>
      <div className={"flex flex-col justify-center text-left"}>
        <p className={"text-green-700 font-bold uppercase"}>{nombreCategoria}</p>
        <div className={"text-green-700 text-justify text-sm font-base | mt-1"}>
          Electrodomésticos
        </div>
        <div className="mt-2">
          <Dropdown
            handleItem={handleElectrodomestico}
            items={electrodomesticos}
            handleClear={handleClearElectro}
            clearItem={clearElectro}
          />
        </div>

        <div className={"my-2 grid grid-cols-1 md:grid-cols-5 gap-2 w-full"}>
          <div className={"listbox-container | md:col-start-1 md:col-end-3"}>
            <div className={"text-green-700 text-justify text-sm font-base | mb-1"}>
              Cantidad
            </div>
            <Dropdown
              handleItem={handleCantidad}
              items={cantidad}
              handleClear={handleClearCantidad}
              clearItem={clearCantidad}
            />
          </div>
          <div className={"listbox-container | md:col-start-3 md:col-end-5"}>
            <div className={"text-green-700 text-justify text-sm font-base | mb-1"}>
              Uso Diario
            </div>
            <Dropdown
              handleItem={handleUsoDiario}
              items={usoDiario}
              handleClear={handleClearUsoDiario}
              clearItem={clearUsoDiario}
              disabled={valoresConsumoState.disableDropdown}
            />
          </div>
          <div className={"mt-8 md:col-start-5 md:col-end-6"}>
            <button
              type={"button"}
              className={
                "inline-flex justify-center w-full px-4 py-1 text-xs font-small text-white bg-green-700 border border-transparent rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black-500 | disabled:opacity-40 disabled:cursor-default disabled:bg-green-600 | shadow-md | hover:bg-green-600 "
              }
              disabled={
                electroDropdownIsEmpty  
                || cantidadDropdownIsEmpty 
                || usoDiarioDropdownIsEmpty
              }
              onClick={handleInputDataOnClick}
            >
              AGREGAR
            </button>
          </div>
        </div>
        <div className={"my-4 max-h-52 overflow-auto"}>
          <Tabla
            ref={tablaRef}
            name={nombreCategoria}
            tupla={inputDataState}
            returnTotalkWhCategoria={handleTotalkWhCategoria}
          />
        </div>
        <div className={"grid grid-cols-5"}>
          <div className={"col-start-1 col-end-2"}>
            <button
              title={"Eliminar tabla"}
              type={"button"}
              /** Deshabilita el botón si no existe elemento en la tabla actual */
              disabled={ valoresConsumoState.ValoresCategoriaCard[nombreCategoria].Cant == 0 }
              onClick={ handleDeleteTableOnClick }
              className={"h-6 w-6 text-gray-500 hover:text-red-500 | disabled:text-gray-300 disabled:cursor-default focus:outline-none"}
            >
              <TrashIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputCard
